import { Form } from 'formik';

import InputText from "atoms/InputText";
import Select from "atoms/Select";


function extractValues(data: any) {
  if (Array.isArray(data)) {
    return data.map(item => item.value).join(',');
  } else {
    return data.value;
  }
}
const inputComponent = (formik: any, { value, ...field }: any, callback: Function[]) => {
  return <InputText
    formik={formik}
    label={field.title}
    id={field.key}
    name={field.key}
    onChange={({ target }: any) => {
      if (field.type === 'file') {
        // if (isUpdate) {
          formik.setFieldValue(field.key, target.files[0].name);
          if (field.callbackOnChanged)
            callback[field.callbackOnChanged](target.files[0]);
        // }
      } else {
        formik.setFieldValue(field.key, target.value);
        if (field.callbackOnChanged)
          callback[field.callbackOnChanged](target.value);
      }
    }}
    value={field.type === 'file' ? undefined : formik.values[field.key]}
    onBlur={({ target: { value } }: any) => {
      field.callbackOnBlur && field.callback && field.callback(field.callbackOnBlur, value)
    }}
    {...field}
  >
    <>
      {field.type === 'file' && (
        <label className="mt-2 text-primary" >
          {formik.values[field.key] ? "Archivo seleccionado  " + formik.values[field.key]: 'No tiene ningún archivo selecionado'}
        </label>
      )}
    </>
  </InputText>
}


const selectComponent = (formik: any, field: any) => {
  return <Select
    formik={formik}
    label={field.title}
    id={field.key}
    name={field.key}
    onChange={(data: any) => {
      formik.setFieldValue(field.key,  extractValues(data));
      field.callbackOnChanged && field.callback && field.callback(field.callbackOnChanged, data)
    }}
    {...field}
  />
}

const mapperComponent: { [key: string]: Function } = {
  text: inputComponent,
  number: inputComponent,
  select: selectComponent,
  file: inputComponent,
}

const FieldsBuilder = ({ formik, structure, callback }: any) => (
  <Form className="needs-validation">
    <div className="d-flex row">
      {structure.map((field: any) => {
        const column = `col-md-${field.column}`
        return (
          <div key={field.key} className={`${column} col-full`}>
            {field.type ? mapperComponent[field.type](formik, field, callback) : null}
          </div>
        )
      })}
    </div>
  </Form>
)


export default FieldsBuilder;
